import Nav from '../../components/breadcrumb';
import PageHeader, { ActionBar, ActionButton, Title } from '../../components/pageheader';
import { Form, Table, Card, Row, Col, Button } from 'react-bootstrap';
import { SortButton } from '../../components/btns';
import { useState, useEffect, useContext } from 'react';
import PagePagination, { usePagination } from '../../components/pagination';
import moment from 'moment';
import currency, { UGX } from '../../components/currency';
import { Link } from 'react-router-dom';
// import { UCWords } from './../../components/resources';
import { useScreenType } from '../../components/custom-hooks';
import { ErrorLoading, PageLoading } from '../../components/loading';
import { activateAccount, dectivateAccount, getAccounts } from '../../resources/api/accounts';
import { UCWords } from '../../components/resources';
import AccountForm from './accounts-form';
import { errorAlert, infoAlert, successAlert } from '../../components/toastr';
import { AppUserContext } from '../../App';


const form_defaults = {
    title: "",
    account_type: "",
    account_no: "",
    account_provider: "",
    opening_balance: ""
}


/**
 * View table items on screens larger than md
 * @param {{
 * srt: {currentField: string, currentOrder: string}
 * handleSort: (field: string) => void
 * items: import('../../resources/api/accounts').AccountObject[]
 * currentPage: number
 * noPageItems: number
 * }} param0 
 */
const ViewDesktop = ({ srt, handleSort, items, currentPage, noPageItems, onClickEdit, activateAccount, deactivateAccount }) => {
    return (
        <Table responsive hover style={{ minWidth: '700px' }}>
            {/* <colgroup>
                <col span="1" style={{ width: "3%" }} />
                <col span="1" style={{ width: "17%" }} />
                <col span="1" style={{ width: "12%" }} />
                <col span="1" style={{ width: "15%" }} />
                <col span="1" style={{ width: "12%" }} />
                <col span="1" style={{ width: "12%" }} />
                <col span="1" style={{ width: "15%" }} />
            </colgroup> */}
            <thead>
                <tr>
                    <th>#</th>
                    <th>Name <SortButton field="title" {...srt} handleSort={handleSort} /></th>
                    <th>Type <SortButton field="account_type" {...srt} handleSort={handleSort} /></th>
                    <th>Provider <SortButton field="account_provider" {...srt} handleSort={handleSort} /></th>
                    <th>Acc No <SortButton field="account_no" {...srt} handleSort={handleSort} /></th>
                    <th style={{ textAlign: 'right' }}>Open Bal <SortButton field="opening_balance" {...srt} handleSort={handleSort} /></th>
                    <th style={{ textAlign: 'right' }}>Avail Bal <SortButton field="available_balance" {...srt} handleSort={handleSort} /></th>
                    <th>Status <SortButton field="isActive" {...srt} handleSort={handleSort} /></th>
                    <th>...</th>
                </tr>

            </thead>
            <tbody>
                {items.map((e, i) => (
                    <tr key={i}>
                        <td>{(currentPage - 1) * noPageItems + i + 1}</td>
                        <td><Link to={`/app/accounts/${e.id}`}>{e.title}</Link></td>
                        <td>{UCWords(e.account_type.replace(/-/g, " "))}</td>
                        <td>{e.account_provider || 'n/a'}</td>
                        <td>{e.account_no || 'n/a'}</td>
                        <td style={{ textAlign: 'right' }}>{currency(e.opening_balance).format()}</td>
                        <td style={{ textAlign: 'right' }}>{currency(e.available_balance).format()}</td>
                        <td>{e.isActive ? "Active" : "Inactive"}</td>
                        <td>
                            <Button variant="link" size="sm" className='text-danger p-0 mx-1' onClick={() => onClickEdit(e.id)}>
                                <i className="fas fa-pencil-alt" />
                            </Button>
                            {e.isActive &&
                                <Button variant="link" size="sm" className='text-danger p-0 mx-1' onClick={() => deactivateAccount(e.id)}>
                                    <i className="fas fa-ban" />
                                </Button>
                            }
                            {!e.isActive &&
                                <Button variant="link" size="sm" className='text-success p-0 mx-1' onClick={() => activateAccount(e.id)}>
                                    <i className="fas fa-check-circle" />
                                </Button>
                            }
                        </td>
                    </tr>
                ))}
            </tbody>
        </Table>
    )
}

/**
 * view items on screens smaller than md
 * @param {{
 * srt: {currentField: string, currentOrder: string}
 * handleSort: (field: string) => void
 * items: import('../../resources/api/accounts').AccountObject[]
 * }} param0 
 */
const ViewMobile = ({ srt, handleSort, items, onClickEdit, activateAccount, deactivateAccount }) => {

    const { profile } = useContext(AppUserContext);

    return (
        <div className="my-3">
            <div className="mb-3" style={{ whiteSpace: 'nowrap', overflowX: 'auto', maxWidth: '100%' }}>
                <span className="small text-nowrap m-1 py-1 px-2 bg-teal text-white rounded-pill">
                    Name <SortButton field="title" {...srt} handleSort={handleSort} />
                </span>
                <span className="small text-nowrap m-1 py-1 px-2 bg-teal text-white rounded-pill">
                    Type <SortButton field="account_type" {...srt} handleSort={handleSort} />
                </span>
                <span className="small text-nowrap m-1 py-1 px-2 bg-teal text-white rounded-pill">
                    Balance <SortButton field="available_balance" {...srt} handleSort={handleSort} />
                </span>
            </div>
            {items.map((e, i) => (
                <Card className="my-2 shadow-sm" key={i}>
                    <Card.Body className="px-3">
                        <div>
                            <h4 className="h4 d-flex justify-content-between">
                                <Link to={`/app/accounts/${e.id}`}>
                                    {e.title}
                                </Link>
                                <span>
                                    {(profile.permission_level === 1) &&
                                        <Button variant="link" size="sm" className='text-danger p-0 mx-1' onClick={() => onClickEdit(e.id)}>
                                            <i className="fas fa-pencil-alt" />
                                        </Button>
                                    }

                                    {e.isActive &&
                                        <Button variant="link" size="sm" className='text-danger p-0 mx-1' onClick={() => deactivateAccount(e.id)}>
                                            <i className="fas fa-ban" />
                                        </Button>
                                    }
                                    {!e.isActive &&
                                        <Button variant="link" size="sm" className='text-success p-0 mx-1' onClick={() => activateAccount(e.id)}>
                                            <i className="fas fa-check-circle" />
                                        </Button>
                                    }
                                </span>

                            </h4>
                            <p className="mb-1"><i className='fas fa-question fa-fw me-1' />{UCWords(e.account_type.replace(/-/g, " "))}</p>
                            <p className="mb-1"><i className='fas fa-building-columns fa-fw me-1' /> {e.account_provider || 'n/a'}</p>
                            <p className="mb-1"><i className='fas fa-hashtag fa-fw me-1' /> {e.account_no || 'n/a'}</p>
                            <p className="mb-1"><i className='fas fa-coins fa-fw me-1' /> {UGX(e.opening_balance).format()}</p>
                            <p className="mb-1"><i className='fas fa-magnifying-glass-dollar fa-fw me-1' /> {UGX(e.available_balance).format()}</p>
                            {/* <p className="mb-1"><i className='fas fa-calendar-plus fa-fw me-1' /> {moment(e.date_added).format("DD MMM YYYY")}</p> */}
                        </div>

                        <div className="d-flex justify-content-between mt-3 text-muted small">
                            <span>Added on {moment(e.date_added).format("DD MMM YYYY")}</span>
                            <span className="text-muted font-weight-normal">{e.isActive ? "ACTIVE" : "INACTIVE"}</span>
                        </div>
                    </Card.Body>
                </Card>
            ))}
        </div>
    )
}


const ViewAccounts = () => {

    const navItems = [{
        title: 'Accounts'
    }];

    const [srt, setSrt] = useState({
        currentField: 'title',
        currentOrder: 'asc'
    });

    const [noPageItems, setNoPageItems] = useState(10);
    const [displayItems, setDisplayItems] = useState([]);
    const [items, setItems] = useState([]);
    const [orginalItems, setOriginalItems] = useState([]);
    const [search, setSearch] = useState({ val: '', field: 'title' });

    const [loaded, setLoaded] = useState(false);
    const [error, setError] = useState();

    const screenType = useScreenType();
    const [PAGE, NOPAGES, setPage] = usePagination(items.length, noPageItems);

    const [show, setShow] = useState(false);
    const [edit_action, setEditAction] = useState("create");

    const [staffDetails, setStaffDetails] = useState(form_defaults);

    const { profile } = useContext(AppUserContext);


    const onClickEdit = (id, type = "edit") => {
        if (profile.permission_level > 1) {
            errorAlert("You do not have the permission to edit an account details");
            return;

        }
        let details = orginalItems.find(i => i.id === id);
        setStaffDetails(details);
        setEditAction(type || "edit");
        setShow(true);
    }

    const onClickNew = () => {
        setStaffDetails(form_defaults);
        setEditAction("create");
        setShow(true);
    }

    const onUploadStaff = details => {
        if (edit_action === "create") {
            setOriginalItems(items => items.concat(details));
        } else {
            let items = [...orginalItems];

            items.splice(
                items.findIndex(i => i.id === details.id),
                1,
                details
            );
            setOriginalItems(items);
        }
    }

    const activate = id => {

        infoAlert("Activating Account, Please Wait...");

        activateAccount(id)
            .then(({ message }) => {
                successAlert(message);

                let items = [...orginalItems],
                    idx = items.findIndex(i => i.id === id),
                    _item = items[idx];

                items.splice(
                    idx,
                    1,
                    { ..._item, isActive: true }
                );
                setOriginalItems(items);
            })
            .catch(errorAlert)
    }

    const deactivate = id => {

        if (profile.permission_level > 1) {
            errorAlert("You do not have the permission to deactivate an account");
            return;

        }

        infoAlert("Activating Account, Please Wait...");

        dectivateAccount(id)
            .then(({ message }) => {
                successAlert(message);

                let items = [...orginalItems],
                    idx = items.findIndex(i => i.id === id),
                    _item = items[idx];

                items.splice(
                    idx,
                    1,
                    { ..._item, isActive: false }
                );
                setOriginalItems(items);
            })
            .catch(errorAlert)
    }




    /**
     * whenever the page changes, scroll back to the top of the list.
     */
    useEffect(() => {
        if (PAGE === 1) return;
        window.scrollTo({ top: 100, behavior: "smooth" });
    }, [PAGE])

    /**
     * whenever the value and field change ie. a search, 
     * filter the items and view on the page.
     */
    useEffect(() => {
        const v = search.val, f = search.field;
        if (v.length < 2 || f === "") return setItems(orginalItems);
        setItems([...orginalItems.filter(i => i[f].toLowerCase().indexOf(v.toLowerCase()) !== -1)]);
    }, [search.val, search.field, orginalItems]);


    /**
     * get the items
     */
    useEffect(() => {

        getAccounts(true)
            .then(({ accounts }) => {
                setOriginalItems(accounts);
                setItems(accounts);
            })
            .catch(e => setError(e))
            .finally(() => setLoaded(true))

    }, [])


    /**
     * Update display items whenever 
     * (1) => the page changes 
     * (2) => the number of items a page changes 
     * (3) => items change in any way
     */
    useEffect(() => {

        const ditems = [],
            start = (PAGE * noPageItems) - noPageItems,
            end = (PAGE * noPageItems) > items.length ? items.length : PAGE * noPageItems;

        for (let index = start; index < end; index++) {
            ditems.push(items[index]);
        }

        setDisplayItems(ditems);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [PAGE, noPageItems, JSON.stringify(items)])

    /**
     * Is triggered when 
     * (1) => user has changed the sort field
     * (2) => user has changed sort order
     * (3) => user has changed length of items (i.e., there are new items in the page)
     */
    useEffect(() => {

        const comp = (a, b) => {
            if (srt.currentOrder === 'asc') {
                return (a[srt.currentField] > b[srt.currentField]) ? 1 : ((a[srt.currentField] < b[srt.currentField]) ? -1 : 0);
            }
            return (a[srt.currentField] < b[srt.currentField]) ? 1 : ((a[srt.currentField] > b[srt.currentField]) ? -1 : 0);
        }

        setItems(items => [...items].sort(comp));

    }, [srt.currentField, srt.currentOrder, items.length])

    /**
     * handle when someone clicks the sort button
     * @param {string} field 
     */
    const handleSort = field => {
        if (field === srt.currentField) {
            setSrt(d => ({ ...d, currentOrder: d.currentOrder === 'asc' ? 'desc' : 'asc' }));
        } else {
            setSrt(d => ({ currentField: field, currentOrder: 'asc' }));
        }
    }

    if (!loaded) return <PageLoading>Loading all accounts...</PageLoading>;

    if (error) return <ErrorLoading>{error}</ErrorLoading>;


    return (
        <>
            <Nav items={navItems} />

            <PageHeader maxWidth="1000">
                <Title>Accounts</Title>
                <ActionBar>
                    <ActionButton onClick={onClickNew}>
                        <i className='fas fa-plus-circle me-2' />New Account
                    </ActionButton>
                </ActionBar>
            </PageHeader>

            <div className="max-1000">

                <Row xs={{ cols: "auto" }} className="align-items-center justify-content-md-end mb-3 flex-nowrap g-0">
                    <Col>

                        <Form.Control placeholder="Search For" size="sm"
                            value={search.val}
                            onChange={e => setSearch({ ...search, val: e.currentTarget.value })}
                        />
                    </Col>
                    <Col>
                        <span className="mx-1">in</span>
                    </Col>
                    <Col>
                        <Form.Select as="select" size="sm"
                            value={search.field}
                            onChange={e => setSearch({ ...search, field: e.currentTarget.value })}
                        >
                            <option value="title">Name</option>
                            <option value="account_type">Type</option>
                        </Form.Select>
                    </Col>

                </Row>

                {screenType === 'desktop' ?
                    <ViewDesktop
                        srt={srt}
                        handleSort={handleSort}
                        items={displayItems}
                        noPageItems={noPageItems}
                        currentPage={PAGE}
                        onClickEdit={onClickEdit}
                        activateAccount={activate}
                        deactivateAccount={deactivate}
                    /> :
                    <ViewMobile
                        srt={srt}
                        handleSort={handleSort}
                        items={displayItems}
                        onClickEdit={onClickEdit}
                        activateAccount={activate}
                        deactivateAccount={deactivate}
                    />
                }

                <div className="d-flex flex-column flex-sm-row justify-content-between align-items-center">
                    <Row xs={{ cols: "auto" }} className="align-items-center g-0 flex-nowrap mb-2">

                        <Col className="me-2 text-nowrap">No Items:</Col>
                        <Col>
                            <Form.Select
                                value={noPageItems}
                                onChange={e => setNoPageItems(parseInt(e.currentTarget.value))}
                                size="sm"
                                style={{ maxWidth: '100px' }}
                            >
                                <option value={10}>10</option>
                                <option value={25}>25</option>
                                <option value={50}>50</option>
                                <option value={100}>100</option>
                            </Form.Select>
                        </Col>

                        <Col className="ms-2 text-nowrap">{items.length} of {orginalItems.length}</Col>
                    </Row>
                    <PagePagination
                        page={PAGE}
                        no_pages={NOPAGES}
                        setPage={setPage}
                    />
                </div>
            </div>

            <AccountForm
                accountDetails={{ details: staffDetails, setDetails: setStaffDetails }}
                action={edit_action}
                show={{ show, setShow }}
                onUpload={onUploadStaff}
            />

        </>
    )
}


export default ViewAccounts;